<div>
  <h2 matDialogTitle>Adicionar preço</h2>
  <mat-dialog-content>
    <form [formGroup]="form" autocomplete="off">
      <!-- input de valor -->
      <div class="mt-2 col-md-12">
        <mat-form-field class="width-100" appearance="outline">
          <mat-label>Valor</mat-label>
          <input
            matInput
            (keydown)="validateOnlyNumbers($event)"
            type="text"
            [formControl]="form.get('valor')"
            style="text-align: right;"
          />
          <span matPrefix>R$&nbsp;</span>
        </mat-form-field>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').hasError('existSpecialChar') &&
            this.form.get('valor').touched
          "
        >
          Valor inválido, não aceita pontuação!
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').hasError('required') &&
            this.form.get('valor').touched
          "
        >
          O valor é obrigatório.
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').touched &&
            form.get('valor').hasError('valueMinZero')
          "
        >
          Insira um valor maior que 0
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').touched &&
            form.get('valor').hasError('before_split')
          "
        >
          Inválido: erro na parte inteira
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').touched &&
            form.get('valor').hasError('after_split')
          "
        >
          Inválido: erro na parte decimal
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').touched &&
            form.get('valor').hasError('errorComma')
          "
        >
          Inválido: excesso de virgulas
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').touched && form.get('valor').hasError('errorDots')
          "
        >
          Inválido: excesso de pontos
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').touched && form.get('valor').hasError('max_value')
          "
        >
          Inválido: passou dos limites
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').touched &&
            form.get('valor').hasError('notNumbers')
          "
        >
          Inválido: insira números
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('valor').touched &&
            form.get('valor').getError('invalidNumber')
          "
        >
          Valor inválido
        </small>
      </div>
      <!-- auto complete de tabela preco -->
      <div class="mt-2 col-md-12">
        <fast-autocomplete
          #input
          required
          [autoFirst]="false"
          [control]="form.get('tabela_preco')"
          [domain_id]="tokenService.getDomain().id"
          [entityService]="tabelaPrecoService"
          displayField="nome"
          placeholder="Tabela de preço."
          (clearSelection)="form.get('tabela_preco').reset()"
          [initDataWithEmpty]="true"
          [messages]="{
            required: 'Tabela de preco é requerida.',
            typeIs: 'Tabela de preço inválida.',
            isEmptyValue: 'Valor inválido: remova os espaços em branco!'
          }"
          autocomplete="off"
          [insertType]="'tabela_preco'"
          [value_order]="'nome'"
          [pageValue]="'0'"
          [pageSizeValue]="'10'"
        ></fast-autocomplete>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="m-0" style="margin-bottom: -10px!important;">
    <div
      class="w-100 mt-2 d-flex justify-content-between justify-content-start align-items-center"
    >
      <button
        type="button"
        mat-stroked-button
        id="cancelar-edit-preco-produto-btn"
        [matDialogClose]="undefined"
      >
        Cancelar
      </button>
      <button
        id="salvar-preco-produto-btn"
        mat-raised-button
        type="submit"
        color="primary"
        (click)="salvar()"
        [disabled]="!form.valid"
      >
        Salvar
      </button>
    </div>
  </mat-dialog-actions>
</div>
